import React from "react";
import CustomButtonLoader from "../global/CustomButtonLoader.component";
import resetPasswordImg from "../../assets/images/auth/iMac-Pink.svg";
import { useNavigate } from "react-router-dom";

const LockScreenForm = ({ t, refId }) => {
  const navigate = useNavigate();

  return (
    <div className="d-flex flex-column my-5 pt-3 pb-2">
      <img
        src={resetPasswordImg}
        className={"mx-auto"}
        style={{ width: "64px", height: "64px" }}
        alt={t("reset_password_img")}
      />
      <p className="my-0 pe-3 text-blue-800 fw-medium text-center mt-3">
        {t("account_locked")}!!
      </p>
      <p className="my-0 pe-3 mt-1 fw-medium text-center text-blue-gray-500 cm-sm-txt">
        {t("your_account_lock_due_failed_login_attempt")}
      </p>
      <CustomButtonLoader
        showLoadingState={false}
        disabled={false}
        icon={""}
        buttonLabel={t(`${t("reset_password")}`)}
        colorTheme={"blue"}
        buttonStyle={"mx-auto mt-4 mb-5 py-2 px-3 fw-medium"}
        handleOnClick={() => {
          navigate(`/forgot-password?refId=${refId}`);
        }}
      />
    </div>
  );
};

export default LockScreenForm;
